import { render, staticRenderFns } from "./ChartTopObrasTv.vue?vue&type=template&id=483362b4&"
import script from "./ChartTopObrasTv.vue?vue&type=script&lang=js&"
export * from "./ChartTopObrasTv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports